import React, { useEffect, useState } from 'react'

import { useParams ,useNavigate} from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setLogin } from '../../state/GlobalState'
import jwtDecode from 'jwt-decode';
import { setNotificationCount } from '../../state/GlobalState'


const RedirectLogin = () => {

 
    const searchParams = new URLSearchParams(window.location.search);
    const [token,setToken] = useState("");
    // const jsonuserDetails=searchParams.get('userDetails');

   
   
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loginDetail,setLoginDetail]=useState(null);
    

    function getUrlParams(url) {
      const params = {};

      console.log(url)
      const urlParts = url.split("?");
    
      if (urlParts.length > 1) {
        const queryString = urlParts[1];
        const paramPairs = queryString.split("&");
    
        paramPairs.forEach((pair) => {
          const [key, value] = pair.split("=");
          params[key] = value;
        });
      }
    
      return params;
    }

    const decodeUserDetails=(userdetails)=>{

      const decodedData = decodeURIComponent(userdetails.replace(/%22/g, '"'));

      return decodedData;
    }
   

      useEffect(()=>{


        const currentURL = window.location.href;
       
       
        const searchParams=getUrlParams(currentURL)

       

        setToken(searchParams.token);
       
        const decodedUserDetails=decodeUserDetails(searchParams.userDetails)

        try {
          setLoginDetail(JSON.parse(decodedUserDetails));
          
          } catch (error) {
            console.error( error);
           console.log("error parsing data")
          }
      },[])


      // console.log(loginDetail)
      // console.log(loginDetail.vendorRole.name)
      useEffect(()=>{
        // const decodedToken = jwtDecode(token);
        if(loginDetail!==null)
        {
          dispatch(setLogin({
            user: loginDetail.email,
            token: token,
            name: loginDetail.name,
            role:[loginDetail.roles.name],
            userDetails:loginDetail,
  
          }))

          dispatch(setNotificationCount({
            count: 1,
          }))
          
          navigate('/myprofile');
        }
        else
        {
          // alert("Error Auto Loging in Please Re-Login")
          console.log("waiting for the logindetails");
        }  
      
      },[loginDetail])
    

    return (
        <div>RedirectLogin</div>
    )
}

export default RedirectLogin